import { createFileRoute } from "@tanstack/react-router";
import CompanyInfoForm from "@/components/company/form-company-info";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/companies",
)({
  component: CompaniesPage,
});

function CompaniesPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "companies", actions: ["read", "update"] }]}
    >
      <div className="max-w-4xl ">
        <CompanyInfoForm />
      </div>
    </RouteGuardPermissions>
  );
}
